import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ScanQROrderEffects } from './scan-qr-order.effects';
import { IScanQROrderFeature } from './scan-qr-order.feature.state';
import { ScanQROrderReducer } from './scan-qr-order.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IScanQROrderFeature>('ScanQROrderFeature'), ScanQROrderReducer),
    EffectsModule.forFeature([ScanQROrderEffects]),
  ],
})
export class ScanQROrderStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ScanQROrderStateModule
  ) {
    if (parentModule) {
      throw new Error('ScanQROrderStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
